<script setup lang="ts">
import { computed, ref } from 'vue'
import { releaseDetail } from '../releaseDetail'
import { ReleaseId } from '../enums/releases'
import { Expansions } from '../enums/expansions'
import ExpansionCard from '../components/ExpansionCard.vue'
// import TheFooter from './TheFooter.vue'

const emit = defineEmits(['showPastSeasons'])

const expansionOpen = ref<ReleaseId>()
const isShowPastSeasons = ref(false)
const now = Date.now()

const isMajorExpansion = (id: ReleaseId) => ([
  Expansions.CurseOfOsiris, Expansions.Warmind, Expansions.Forsaken, Expansions.AnnualPass,
  Expansions.Shadowkeep, Expansions.BeyondLight, Expansions.Anniversary30th,
  Expansions.TheWitchQueen, Expansions.Lightfall, Expansions.FinalShape,
  Expansions.EdgeOfFate, Expansions.Renegades] as ReleaseId[]).includes(id)
const activeExpansions = computed(() => Array.from(releaseDetail.values())
  .filter(x => (isShowPastSeasons.value || x.active) && !x.hidden && x.date.getTime() <= now)
  .sort((a, b) => +isMajorExpansion(a.id) - +isMajorExpansion(b.id))
  .sort((a, b) => b.date.getTime() - a.date.getTime()))

function toggle(expansionId: ReleaseId) {
  if (expansionOpen.value === expansionId) {
    expansionOpen.value = undefined
  } else {
    expansionOpen.value = expansionId
  }
}

function showPastSeasons() {
  isShowPastSeasons.value = !isShowPastSeasons.value
  emit('showPastSeasons') // Later maybe
}
</script>

<template>
  <div class="w-full max-w-[48rem] px-2 py-4 text-zinc-200 mx-auto">
    <!-- <RouterLink to="/" class="flex items-center text-lg"><img src="../assets/caret.svg" class="h-6 w-6 invert rotate-90" />Go back</RouterLink> -->
    <h1 id="expansions" class="text-center text-4xl my-2 border-zinc-500 border-b pb-2">Expansion information
      <!-- <button v-if="isShowPastSeasons" class="text-sm p-2 align-middle hover:bg-white/10" @click="showPastSeasons">Hide sunset or unavailable content</button>
      <button v-else class="text-sm p-2 align-middle hover:bg-white/10" @click="showPastSeasons">Show sunset or unavailable content</button> -->
    </h1>
    <div class="flex flex-wrap gap-4 justify-center text-black">
      <ExpansionCard
        v-for="expansion in activeExpansions"
        :key="expansion.id"
        :expansion="expansion"
        :open="expansionOpen === expansion.id"
        @toggle="() => toggle(expansion.id)"
      />
    </div>
    <!-- <TheFooter /> -->
  </div>
</template>